// extracted by mini-css-extract-plugin
export var errorBanner = "_l6-2";
export var scroller = "_l6-0";
export var thinking = "_l6-1";
export var visuallyHidden = "_l6-3";